export { CAPScore } from './CAPScore'
export type { CAPScoreProps } from './types'
